var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatpaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1766 8.66845C27.763 3.13005 33.0158 6.49333 30.4187 11.2435C27.9677 14.8533 23.2954 12.8936 25.1766 8.66845Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6215 10.5597C15.6143 17.3942 10.3682 3.72777 16.0703 3.91599C18.854 4.43213 20.7357 7.9218 19.6215 10.5597Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5019 19.7122C31.8279 22.6542 34.9495 22.7604 36.6661 21.029C37.7056 20.4768 37.9184 19.2468 37.9503 17.8795C37.2117 13.5299 32.9873 17.0629 32.5019 19.7122Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23947 11.1714C8.92772 12.308 14.5594 17.5275 9.43193 19.1622C3.47106 21.4503 -1.36154 8.20908 6.23947 11.1714Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4118 19.3146L16.4533 19.2728L16.4895 19.2265C18.2497 16.9764 20.0791 16.509 21.6682 16.8363C23.3526 17.1832 24.9897 18.4706 26.1342 20.1483L26.1502 20.1718L26.1676 20.1944C26.8846 21.127 27.8035 22.0187 28.671 22.8606L28.701 22.8898C30.1078 24.255 31.3664 25.4931 32.0192 26.8411C32.3331 27.4891 32.4905 28.135 32.4564 28.8108C32.4224 29.4855 32.1941 30.2565 31.6369 31.1504C29.3147 34.7484 25.0628 35.7886 20.8845 35.2873C18.8106 35.0386 16.8245 34.4127 15.2272 33.5869C13.6034 32.7476 12.4963 31.7626 12.0231 30.8683C10.8795 28.707 10.6105 26.9946 10.6525 25.7492C10.6946 24.5022 11.0504 23.6612 11.2516 23.2366C11.4325 22.8547 11.8117 22.2943 12.3054 21.7655C12.8051 21.2304 13.3374 20.8188 13.79 20.6348C14.0973 20.5099 14.3584 20.4117 14.5919 20.3247C14.6115 20.3174 14.6311 20.3101 14.6506 20.3028C14.8569 20.2259 15.057 20.1514 15.2369 20.0761C15.6588 19.8996 16.037 19.6924 16.4118 19.3146Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatpaw);
export default __webpack_public_path__ + "static/media/catpaw.166dbcbd794623325e8ba2443eabceea.svg";
export { ForwardRef as ReactComponent };